import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@longy/web-components'
import { Link, useLocation } from '@tanstack/react-router'
import { ChevronDown } from 'lucide-react'

import { HeaderNavEntry, isHeaderNavEntryActive } from '../../utils/headerNav'

const entryClassName = (isActive: boolean) =>
    `flex items-center gap-1 text-sm font-medium transition-colors hover:text-primary focus-visible:outline-none ${
        isActive ? 'text-primary' : 'text-brand-gray'
    }`

export const HeaderDesktopNav = ({ entries }: { entries: HeaderNavEntry[] }) => {
    const location = useLocation()

    return (
        <nav className="hidden items-center gap-8 lg:flex">
            {entries.map((entry) => {
                const className = entryClassName(isHeaderNavEntryActive(entry, location.pathname))

                if (entry.kind === 'link') {
                    return (
                        <Link key={entry.href} to={entry.href} className={className}>
                            {entry.label}
                        </Link>
                    )
                }

                return (
                    <DropdownMenu key={entry.id}>
                        <DropdownMenuTrigger className={className}>
                            {entry.label}
                            <ChevronDown className="size-4" />
                        </DropdownMenuTrigger>
                        {/* Capped because the cms pages group is the complete index and can run to
                            hundreds of entries. */}
                        <DropdownMenuContent align="start" className="max-h-96 overflow-y-auto">
                            {entry.items.map((item) => (
                                <DropdownMenuItem asChild key={item.href}>
                                    <Link to={item.href}>{item.label}</Link>
                                </DropdownMenuItem>
                            ))}
                        </DropdownMenuContent>
                    </DropdownMenu>
                )
            })}
        </nav>
    )
}
